<template>
  <div class="container" v-if="isShow">
    <div class="top_img">
      <img :src="storeData.imageUrl" alt="" style="width: 100%; height: 100%" />
    </div>
    <div class="information">
      <div class="des_test">Please order from our partner below</div>
      <div class="information_img">
        <!-- <img :src="storeData.logoUrl" alt="" /> -->
        <img src="../assets/images/eat1stlogo.png" alt="" />
      </div>
      <div>
        <div class="information_title">
          <!-- {{ storeData.storeName }} -->
          Eat1st
        </div>
        <!-- <div class="information_button">
                    <button :class="[{ color_yellow:index % 3 == 0 },{ color_red:index % 3 == 1 },{ color_blue:index % 3 == 2 }]" v-for="(item,index) in storeData.tags ? storeData.tags.split('·'): [] " :key="index">{{item}}</button>
                </div>
                <div class="information_star">
                    <van-rate v-model="storeData.evaluateScore" color="#ffd21e" void-icon="star" void-color="#eee"  gutter="2" :readonly="true"/>
                    <span class="num">({{storeData.evaluateNum}})</span>
                </div> -->
      </div>
      <div class="information_footer">
        <div class="information_footer_left">
          <img src="../assets/images/定位.png" alt="" />
        </div>
        <div class="information_footer_center">
          <van-row>
            <van-col span="22" class="address">{{ storeData.address }}</van-col>
          </van-row>
        </div>
      </div>
      <div class="information_footer_phone">
        <div class="information_footer_right">
          <img src="../assets/images/电话.png" alt="" />
        </div>
        <div class="information_footer_center">
          {{ storeData.phone }}
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="footer_title" v-if="storeData.remark != ''">
        Store introduction:<br />
        {{ storeData.remark }}
      </div>
      <div class="footer_button">
        <!-- <div><van-button type="primary" class="v-button" @click="login">Register and download APP</van-button></div>
                <div class="footer_link"><a href="#" @click="getDownloadurl">Do not register for now,download APP immediately</a></div> -->
        <!-- <div class="footer_btn"> -->
        <div class="des_test">Please download Eat1st for more details</div>
        <div>
          <img
            src="../assets/images/iosdown1.png"
            alt=""
            class="btn_down"
            @click="getDownloadurl('IOS')"
          />
        </div>
        <div>
          <img
            src="../assets/images/down1.png"
            alt=""
            class="btn_down"
            @click="getDownloadurl('ANDROID')"
          />
        </div>
        <!-- </div> -->
        <!-- <div class="footer_link"><a href="#" @click="login">Register and download APP</a></div> -->
      </div>
    </div>
  </div>
</template>
<script>
import {
  getStoreDetail,
  getDownloadurl,
  getDownloadAndroid,
  getDownloadIos,
} from "../api/index";
import { Toast } from "vant";
export default {
  data() {
    return {
      storeId: 0,
      isShow: false,
      storeData: {},
    };
  },
  created() {
    this.storeId = this.$route.query.storeId; // '1473193209966489602'
    // this.storeId = this.getParam(window.location.href,'storeId')
    if (this.storeId && this.storeId != undefined && this.storeId != "") {
      localStorage.setItem("storeId", this.storeId);
      this.getStore();
      this.isShow = true;
    } else {
      this.isShow = false;
      let url = window.location.origin;
      window.open(url + "/download/user/", "_self");
    }
  },
  methods: {
    getParam(url, name) {
      try {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = url.split("?")[1].match(reg);
        if (r != null) {
          return r[2];
        }
        return ""; //如果此处只写return;则返回的是undefined
      } catch (e) {
        return ""; //如果此处只写return;则返回的是undefined
      }
    },

    getStore() {
      getStoreDetail({ storeId: this.storeId, type: 1 }).then((res) => {
        if (res.code == 1) {
          this.storeData = res.data;
        }
      });
    },
    login() {
      this.$router.push("/login");
    },
    getDownloadurl(index) {
      // let type = null;
      // var u = navigator.userAgent;
      // var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      // var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
      // if(isiOS == true) {
      //     type = 2;
      // }else if(isAndroid == true){
      //     type = 1;
      // }

      // type = index*1;
      // getDownloadurl({sysType:type}).then(res => {
      //     if(type == 1){
      //         window.location.href = res.data;
      //     }else {
      //        Toast('敬請期待')
      //     }
      // })
      if (index == "ANDROID") {
        getDownloadAndroid({ sysType: "ANDROID", storeId: this.storeId }).then(
          (res) => {}
        );
        window.location.href = "market://details?id=com.xdwl.click";
      } else {
        getDownloadIos({ sysType: "IOS", storeId: this.storeId }).then(
          (res) => {}
        );
        window.location.href = "https://apps.apple.com/cn/app/id1618145052";
      }
    },
  },
};
</script>
<style scoped>
.container {
  /* height: 100vh; */
}
.top_img {
  width: 10.8rem;
  height: 6.24rem;
  /* background: url('../assets/images/背景头图.png') no-repeat;
    background-size: 100% 100%; */
}

.information {
  padding: 0.5rem 1rem;
  /* height: 5.5rem; */
  background: url("../assets/images/店铺背景.png") no-repeat;
  background-size: 101% 101%;
}

.information_img {
  height: 1.4rem;
  margin: 0 auto;
  text-align: center;
}

.information_img img {
  width: 1.4rem;
  height: 1.4rem;
}
.information_title {
  font-size: 0.46rem;
  font-weight: 800;
  color: #080808;
  font-family: PingFang SC;
  text-align: center;
  margin-top: 0.4rem;
}
.information_button {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  margin-top: 0.19rem;
}
.information_button button {
  margin-right: 0.16rem;
}
.color_yellow {
  border: 0.02rem solid #fec501;
  border-radius: 0.1rem;
  padding: 0.09rem 0.29rem;
  color: #fec501;
  font-size: 0.3rem;
  background: rgba(254, 197, 1, 0.05);
}
.color_red {
  border: 0.02rem solid #fa7268;
  border-radius: 0.1rem;
  padding: 0.09rem 0.29rem;
  color: #fa7268;
  font-size: 0.3rem;
  background: rgba(254, 197, 1, 0.05);
}
.color_blue {
  border: 0.02rem solid #448aff;
  border-radius: 0.1rem;
  padding: 0.09rem 0.29rem;
  color: #448aff;
  font-size: 0.3rem;
  background: rgba(254, 197, 1, 0.05);
}
.information_star {
  text-align: center;
  vertical-align: middle;
  display: flex;
  justify-content: center;
  align-content: center;
  margin-top: 0.19rem;
}
.num {
  font-size: 0.36rem;
  font-family: PingFang SC;
  font-weight: bold;
  color: #999999;
  margin-left: 0.21rem;
}
.information_footer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 0.52rem;
  height: 0.72rem;
  line-height: 0.36rem;
}
.information_footer_phone {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 0.32rem;
  height: 0.72rem;
}
.flex_start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.information_footer_left {
  margin-right: 0.3rem;
}
.information_footer_left img {
  width: 0.4rem;
  height: 0.46rem;
}
.information_footer_center {
  font-size: 0.34rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #999999;
  text-align: left;
  flex: 1;
}
.information_footer_right {
  margin-right: 0.2rem;
}
.information_footer_right img {
  width: 0.46rem;
  height: 0.46rem;
}
.line {
  width: 0.04rem;
  height: 0.63rem;
  background: #dddddd;
  border-radius: 0.02rem;
  float: right;
}
.footer {
  /* height: 7.18rem; */
  background: #ffffff;
  padding: 0.5rem 0.76rem 0.5rem 0.77rem;
}
.footer_title {
  text-align: center;
  font-size: 0.36rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #999999;
  height: 1.6rem;
  overflow-y: scroll;
}
.footer_button {
  margin-top: 0.85rem;
}
.des_test {
  font-size: 0.36rem;
  color: #000;
  margin-bottom: 0.2rem;
}
.footer_link {
  /* height: 0.31rem; */
  font-size: 0.32rem;
  font-family: PingFang SC;
  font-weight: 500;
  text-decoration: underline;
  color: #fec501;
  /* line-height: 0.20rem; */
  margin-top: 0.48rem;
}
.footer_link a {
  color: #fec501;
}
.v-button {
  width: 100%;
  height: 1.4rem;
  background: #fec501;
  border-radius: 0.3rem;
  padding: 0.52rem 2.17rem;
  color: #fff;
  border: none;
  font-size: 0.4rem;
}
/deep/ .van-rate__icon {
  font-size: 0.5rem;
}
.address {
  width: 100%;
  line-height: 0.4rem;
}
.phone {
}

.footer_btn {
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn_down {
  width: 8rem;
  height: 1.5rem;
}
.marl35 {
  margin-left: 0.52rem;
}
</style>